import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

// Contextos
import { useToast } from '../../contexts/ToastContext';

// Estilos
import styles from './loginpage.module.css';

// API
import { useUsuarioService } from '../../services/usuarioServices';

function RecuperarSenhaUsuarioCodigoPage() {
    const { showToast } = useToast();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const { alterarSenhaUsuario } = useUsuarioService();

    const idUsuario = searchParams.get('id');

    const [codigo, setCodigo] = useState('');
    const [novaSenha, setNovaSenha] = useState('');
    const [confirmarSenha, setConfirmarSenha] = useState('');
    const [carregando, setCarregando] = useState(false);
    const [erro, setErro] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErro('');

        if (novaSenha !== confirmarSenha) {
            setErro('As senhas não coincidem.');
            return;
        }

        setCarregando(true);

        try {
            const result = await alterarSenhaUsuario({
                idUsuario: idUsuario,
                codigo: codigo.trim(),
                novaSenha: novaSenha.trim(),
            });

            if (result.success) {
                showToast('Senha alterada com sucesso!', 3000, 'success');
                navigate('/');
            } else {
                setErro(result.message || 'Falha na redefinição');
                showToast(result.message, 3000, 'error');
            }
        } catch (error) {
            console.error(error);
            setErro('Erro ao redefinir senha.');
            showToast('Erro ao redefinir senha.', 3000, 'error');
        }

        setCarregando(false);
    };

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>Redefinir Senha (Administrador)</h2>

            <form onSubmit={handleSubmit} className={styles.form}>
                <input
                    type="text"
                    placeholder="Código de 6 dígitos"
                    value={codigo}
                    onChange={(e) => setCodigo(e.target.value)}
                    className={styles.input}
                    required
                />

                <input
                    type="password"
                    placeholder="Nova Senha"
                    value={novaSenha}
                    onChange={(e) => setNovaSenha(e.target.value)}
                    className={styles.input}
                    required
                />

                <input
                    type="password"
                    placeholder="Confirmar Nova Senha"
                    value={confirmarSenha}
                    onChange={(e) => setConfirmarSenha(e.target.value)}
                    className={styles.input}
                    required
                />

                <button type="submit" className={styles.button} disabled={carregando}>
                    {carregando ? 'Salvando...' : 'Salvar Senha'}
                </button>

                {erro && <p className={styles.error}>{erro}</p>}
            </form>
        </div>
    );
}

export default RecuperarSenhaUsuarioCodigoPage;